import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RouteParamsMixin',

  data() {
    return {
      repo: '',
      owner: '',
      provider: ''
    }
  },

  created() {
    const { repo, owner, provider } = this.$route.params
    this.repo = repo
    this.owner = owner
    this.provider = provider
  }
})
